import { Col, Row, Table } from "antd";
import { useDealer } from "../../../../tools/api";
import { useEffect, useState } from "react";
import { complexDigitToman, convertMemory, convertToJalaliWithTime, formatDate, formatTime } from "../../../../tools/tools";
import Loading from "../../../auxiliary/loader/loading";
import { NotFound } from "../../../../sources/svg/svg";

const LeftOver = ({ msisdn = 0, sppurchaseid = null, type = null }) => {
  const { queryBalance, queryActivatedProductsMSISDN } = useDealer();
  const [orginalCredit, setOrginalCredit] = useState(0);
  const [usage, setUsage] = useState(0);

  const [packages, setPackages] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const initial = async () => {
      const respnseBalance = await queryBalance(msisdn);
      if (respnseBalance) {
        setOrginalCredit(respnseBalance?.charginglimitvalueorig);
        setUsage(respnseBalance?.charginglimitvalue);
      }
      CartableListServ();
    };
    initial();
  }, []);

  const CartableListServ = async () => {
    setIsLoading(true);
    let response = await queryActivatedProductsMSISDN(msisdn);
    if (response) {
      setPackages(response);
    }
    setIsLoading(false);
  };

  const switchShowCalcData = (type, value) => {
    if (type === "data") {
      return (
        <span>
          <span dir="ltr">{(value / 1024).toFixed(2)}</span> GB
        </span>
      );
    }
    if (type === "voice") {
      return (
        <>
          <span>
            <span dir="ltr">{value}</span> دقیقه
          </span>
        </>
      );
    }
    if (type === "sms") {
      return (
        <>
          <span>
            <span dir="ltr">{value}</span> عدد
          </span>
        </>
      );
    }
  };
  const switchShowPackage = (type, packageName, isCombo = false) => {
    if (type === "data") {
      return (
        <span>
          {isCombo && <>ترکیبی - </>}
          {packageName?.split("+")?.find((item) => !item.includes("مکالمه", "پیامک"))}
        </span>
      );
    } else if (type === "voice") {
      return (
        <span>
          {isCombo && <>ترکیبی - </>} {packageName?.split("+")?.find((item) => item.includes("مکالمه"))}
        </span>
      );
    } else if (type === "sms") {
      return (
        <span>
          {isCombo && <>ترکیبی - </>}
          {packageName?.split("+")?.find((item) => item.includes("پیامک"))}
        </span>
      );
    } else {
      return "";
    }
  };
  return (
    <>
      <br />
      <br />
      <div className="purchase_detail_360">
        <div className="page_title">اعتبار اصلی</div>
        <div className="page_body">
          {type === 1 ? (
            <>
              <Row>
                <Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
                  <div className="label">میزان مصرف:</div>
                  <div className="value">
                    <span dir="ltr">{complexDigitToman(orginalCredit - usage)}</span> تومان
                  </div>
                </Col>
                <Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
                  <div className="label">سقف اعتبار:</div>
                  <div className="value">
                    <span dir="ltr">{complexDigitToman(orginalCredit)}</span> نومان
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xxl={24}>
                  <p className="noteMsg">جهت پرداخت بدهی خود می‌توانید از طریق سایت آپتل اقدام نمایید</p>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row>
                <Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
                  <div className="label">باقیمانده اعتبار:</div>
                  <div className="value">
                    <span dir="ltr">{complexDigitToman(usage)}</span> تومان
                  </div>
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>
      <div className="purchase_detail_360">
        <div className="page_title">بسته</div>
        <div className="holder-table" style={{ marginTop: "3rem" }}>
          <Table
            className="tbl-normal"
            columns={[
              { title: "نام بسته", dataIndex: "packagename", key: "packagename", width: 150 },
              { title: "تاریخ فعالسازی", dataIndex: "activedate", key: "activedate", width: 150 },
              { title: "تاریخ انقضا", dataIndex: "expiredate", key: "expiredate", width: 150 },
              { title: "حجم مصرف شده", dataIndex: "usage", key: "usage", width: 150 },
              { title: "حجم کل", dataIndex: "balance", key: "balance", width: 150 },
            ]}
            locale={{
              emptyText: (
                <>
                  <NotFound text={"رکوردی یافت نشد."} />
                </>
              ),
            }}
            pagination={{
              showSizeChanger: false,
              position: [""],
            }}
            dataSource={packages.map((item, key) => ({
              key: key,
              packagename: switchShowPackage(
                item.category,
                item.extraPackagePurchase?.productName || item?.productInfo?.stR_PackageName,
                item.productInfo?.inT_PackageType === 2,
              ),
              activedate: (
                <span>
                  {convertToJalaliWithTime(item.startDate)} - {formatTime(new Date(item.startDate))}
                </span>
              ),
              expiredate: (
                <span>
                  {convertToJalaliWithTime(item.endDate)} - {formatTime(new Date(item.endDate))}
                </span>
              ),
              usage: switchShowCalcData(item.category, item.usageValue),
              balance: switchShowCalcData(item.category, item.originValue),
            }))}
          />
        </div>
      </div>
      <Loading isOpen={isLoading} />
    </>
  );
};

export default LeftOver;
